import React from 'react'
import PropTypes from 'prop-types'
import MakeSelecatableList from './SelectableList'

const Tabs = ({ groups, id, select, isSelected, ...props}) => (
  <div className='panel-group' id={id} role='tablist' ariaMultiselectable='true'>
    {groups.map((group, index) => (
      <div className='panel panel-default' key={`tab-group-key-${index}-item`}>
        <div className='panel-heading' role='tab' id={id+'Item'+index+'Head'}>
          <h4 className='panel-title'>
            <a
              role='button'
              onClick={() => ((isSelected(index)? select(null) : select(index)) || true) && (group.onSelect && group.onSelect(index))}
              ariaControls={id+'Item'+index}>
              {group.head({ groups, id, select, isSelected, ...props})}
            </a>
          </h4>
        </div>
        <div
          id={id+'Item'+index}
          className={`panel-collapse collapse ${isSelected(index) && 'in'}`}
          role='tabpanel'
          ariaLabelledby={id+'Item'+index+'Head'}
        >
          <div className='panel-body'>
            {isSelected(index) && group.content({ groups, id, select, isSelected, ...props})}
          </div>
        </div>
      </div>
   ))}
  </div>
)

Tabs.propTypes = {
  groups: PropTypes.arrayOf(PropTypes.shape({
    head: PropTypes.node,
    content: PropTypes.node,
  }))
}

const comp = (a,b) => a === b
export default MakeSelecatableList(comp)(Tabs)



// WEBPACK FOOTER //
// ./src/components/Tabs.js